// import axios from 'axios';
import { serialize } from "object-to-formdata";
import{ UserList, UserOne } from '../models/MemberInfo';
import api from "../apis/Api";

interface GetAllParams {
    townId? : number;
    character? : number;
    nickname? : string;
    username? : string;
    telNo? : string;
    gu?: string;
	dong?: string;
    townName?: string;
    authRole?: string;
    page?: number;
    size?: number;
    sort?: string
    id?: number
}

interface JoinInput {
	townId?: number;
	character?: number;
	nickname?: string;
	username?: string;
	telNo?: string;
    address?: string;
	detailAddress?: string;
    gu?: string;
	dong?: string;
    delDt?: string
}

export const getUser = () =>
  api.get("/user/me").then(res => res.data ?? null);

export const logout = () =>
  api.get("/user/logout2").then(res => res.status);

export const updateMember = (params: any) =>
  api.post("/user/update2", serialize(params)).then(res => res.data);

export const nicknameDuplicate = (nickname: string): Promise<boolean> =>
  api.get<boolean>(`/user/duplicate`, { params: { nickname } }).then(res => res.data);

export const telnoDuplicate = (telNo: string) =>
  api.get(`/user/duplicate`, { params: { telNo } }).then(res => res.data);

export const getUserList = (params: any) =>
  api.get<UserList>(`/api/admin/userlist`, { params }).then(res => res.data);

export const getUserOne = (params: any) =>
  api.get<UserOne>(`/api/admin/userget`, { params }).then(res => res.data);

/* 한곳에 모아서 export default */
export default {
  getUser,
  logout,
  updateMember,
  nicknameDuplicate,
  telnoDuplicate,
  getUserList,
  getUserOne,
};